import { CardBody } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import GroupExperiencesIcon from './GroupExperiencesIcon';
import { T } from '../../../../../../../../../Translations';

function NoExperiences() {
  return (
    <CardBody className="gap-5 p-6 pl-2">
      <div className="flex flex-col w-full items-center bg-[#FAFAFA] h-[14rem] justify-center rounded border-dashed border-2 border-gray-60">
        <GroupExperiencesIcon />
        <div className="font-bold text-md mt-2">
          <T kind="No programs added yet" />
        </div>
        <div className="text-sm">
          <T kind="Click to start adding programs to this section" />
        </div>
      </div>
    </CardBody>
  );
}

export default observer(NoExperiences);
